export default __webpack_public_path__ + "static/model360-mediolan-2022a3ab2b16b89c5872161019f362ee.png";